// A relay gift sent to a Mac from this browser (docs/features/relay-passes.md › Gifts › From a phone): the gift
// page's **Send to my Mac** opens the app with `#relayGift=rg_…`; the app hands it to a Mac it is connected to,
// over that Mac's own link, when the person says so. The wire kind `relayGift` and two seams, each one line in
// app.js:
//
//   takeRelayGift()           at startup, before anything reads the fragment: the token out of the address bar
//                             (fragment.js) and into memory — this module's variable, nowhere else
//   offerRelayGift(mac, link) each time a Mac's link is up: that Mac is one to offer (offer.js)
//
// The card (card.js) asks; what it says comes from offer.js. The amount is the site's `POST /api/relay/gift`
// describe — the same call the Mac makes, from the same cookie-less fetch — or "this relay data" when not reached.
import { registerWire } from '../core/wire.js'
import { wwwOrigin } from '../core/site.js'
import { savedRooms } from '../core/transport.js'
import { logLine } from '../core/log.js'
import { takeGift } from './fragment.js'
import { GiftOffer } from './offer.js'
import { drawCard } from './card.js'

registerWire('relayGift', (link, payload, message) => link.onRelayGift?.(message))

let offer = null, drawn = '', ticker = null

async function describe(token) {
  const r = await fetch(wwwOrigin() + '/api/relay/gift', {
    method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ token }),
    credentials: 'omit', referrerPolicy: 'no-referrer', cache: 'no-store',
  })
  if (!r.ok) throw Object.assign(new Error('describe ' + r.status), { status: r.status })
  return r.json()
}

function draw() {
  const view = offer?.view() ?? null
  const key = JSON.stringify(view)
  if (key === drawn) return   // unchanged: an open picker stays open
  drawn = key
  drawCard(view, { act: (what) => offer?.act(what), choose: (k) => offer?.choose(k) })
  if (!view) { clearInterval(ticker); ticker = null; offer = null }
}

export function takeRelayGift() {
  const token = takeGift()
  if (!token) return
  logLine('relay gift: a gift link opened here — kept in memory until it is sent or dismissed')
  offer = new GiftOffer(token, { describe, paired: () => savedRooms().length > 0, log: logLine, onChange: draw })
  // links come and go without telling this module: the card follows them every two seconds while it shows
  ticker = setInterval(() => offer?.tick(), 2000)
  draw()
}

export function offerRelayGift(mac) {
  offer?.add(mac)
}
